
import axios from 'axios';

const API_URL = 'http://localhost:4000/api/auth/';

const signin = async (email, password) => {
  const response = await axios.post(`${API_URL}signin`, { email, password });
  return response.data;
};

export default {
  signin,
};

